import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'marketplace-dialog.common.success-status.heading',
		defaultMessage: 'Voila! {appName} is now installed',
		description:
			'The heading of the modal that shows the successful installation of a Marketplace app',
	},
	body: {
		id: 'marketplace-dialog.common.success-status.body',
		defaultMessage: 'You must configure this app before it can send data to your Jira project.',
		description:
			'The body of the modal that shows the successful installation of a Marketplace app',
	},
	configureAppButtonLabel: {
		id: 'marketplace-dialog.common.success-status.configure-app-button-label',
		defaultMessage: 'Configure app',
		description:
			'The label of the button that will take the user to the configuration page of the app they just installed',
	},
	maybeLaterButtonLabel: {
		id: 'marketplace-dialog.common.success-status.maybe-later-button-label',
		defaultMessage: 'Maybe later',
		description:
			'The label of the button that will close the successful installation modal without taking any action',
	},
});
